import { render } from "./SafeInstructions.vue?vue&type=template&id=ccb40b80&scoped=true"
import script from "./SafeInstructions.vue?vue&type=script&lang=js"
export * from "./SafeInstructions.vue?vue&type=script&lang=js"

import "./SafeInstructions.vue?vue&type=style&index=0&id=ccb40b80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccb40b80"]])

export default __exports__